
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`Leswi swi tisiwa hi phurojeke ya
                    <a href="${0}">Folksonomy Engine</a>. U nga
                    kanakani ku nghenelela kumbe ku nyika vuxokoxoko`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`Xitirhisiwa lexi xi ku pfumelela ku lulamisa nxaxamelo wa swiaki. U nga engetela, u susa kumbe u hlela
                nxaxamelo wa swiaki.
                <br>
                Ximunhuhatwa lexi <span class="highlight">␣</span> xi yimela xivandla.
                <br>
                Xihlawulekisi lexi <span class="highlight">↩︎</span> xi yimela ku tsemiwa ka layini. `,
'hb28f1f2ec1744ee9': html`Swihlawulekisi leswi swi tumbuluxiwa no fayeriwa hi vatirhisi eka muxaka wihi na wihi wa matirhiselo. Titwele
                    u ntshunxekile ku engetela swa wena. Swihlawulekisi na mimpimo leyi u yi tumbuluxaka
                    <strong>swi fanele ku va swa ntiyiso</strong>. U nga nghena eka
                    <a href="${0}">nxaxamelo wa tindhawu leti se ti tirhisiwaka hi vaaki</a>
                    kumbe u kambisisa matsalwa ya tindhawu ta
                    <a href="${1}">na njhini ya yona yo lavisisa</a>.`,
's000a5b76bd3a01c2': `Ku layicha swihlawulekisi...`,
's000d98595e959c1e': `Get It On Google Play`,
's013bdc8cf0d3583d': `Hi pfuneni eka swiaki`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's02ce7a2e7c1b020b': `Tiyisisa swibyariwa`,
's03e9c8114521b998': `Ndzi ta hlela swiaki swa kona`,
's05ec315d9308091a': `Xifaniso xa tikhodi ta tikhodi`,
's061eb5af92512c85': `Ku hlayisiwile! Xana u nga pfuna hi yin’wana?`,
's06847c221c4c0bc1': `Ndzi tsakela ku tumbuluxa nhundzu yo [hlamusela xiyimo xa wena xa matirhiselo]...`,
's06f6c6f99db6b552': `Mampela`,
's081e2ad82db71e1d': `Mimpimanyeto leyi Hlanganisiweke`,
's09205907b5b56cda': `No`,
's0b4235aae602a950': `matsalwa lama tinyiketeleke`,
's0bb2d48532acc455': `Download CSV`,
's0d5b7fee0311db68': `Property`,
's0fb218abc2e157ed': `Xifaniso lexi nga tirhiki`,
's100c4928cc74642a': `support the advancement of public health research.`,
's10db5498186c083b': `Khansela swibyariwa`,
's11a18a69b30b65ed': `Hi pfuneni ku lulamisa swihoxo eka nxaxamelo wa swiaki`,
's1205d5f6fccf8e69': `Nkoka wa Nhundzu`,
's15d64a0a6715285a': `Xilotlelo lexintshwa`,
's166bd56d19670a72': `Zoom`,
's19059bf0c4f7c162': `Ndhawu yo hlawula`,
's1a52515ec8ddade8': `Product barcode`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's1dc4daf989c71284': `Hi pfuneni ku lulamisa rungula ra swakudya`,
's1e00019dc454872d': `Hi kombela u nyika vito ra nhundzu hi ku tirhisa xihlawulekisi xa property-name.`,
's1e49126af0935a5b': `Nxaxamelo wa swikumiwa leswi tirhisaka nhundzu leyi`,
's21e73088de6f26f3': `Download on the App Store`,
's255857544a9d5ec0': `Reset`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's2ceb11be2290bb1b': `Cancel`,
's2db7b654c0a9bde0': `Tsala nhundzu leyi`,
's300b3a6ee4e1252d': str`Ku fambisana loku nga riki kahle ${0}% .`,
's33f786bb6b4f0cf4': `Mbuyelo wa Swibyariwa`,
's33f85f24c0f5f008': `Save`,
's34be4af4e8fec4ae': `Ku sungula vutisa vaaki`,
's36d86adc823cbfa6': `Loko u nga si tumbuluxa ndhawu leyintshwa, bula hi yona ni vaaki:`,
's3781d25aa51a736c': `Matsalwa ya Injhini ya Folksonomy`,
's383ae4449428b61e': `Seta xibyariwa nakambe`,
's39bcf88721a1e8ee': `Seta ku hlawuriwa nakambe`,
's39e14e14300694c7': `Matsalwa na Swiletelo`,
's3b430cfa5c1fe7f4': str`Matsalwa ya ${0}`,
's3f4e4b52f230a892': `Xifaniso xa canvas`,
's417b90913e05bc17': `Preview`,
's41f7dca46d3f1b4a': `Value`,
's422bba9636ce2489': `Xifaniso xa le xikarhi`,
's42dd66b2441566fd': `Xifaniso xa le xikarhi`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `Add a nutrient`,
's453ab0dbb9b5c777': `Cinca sayizi hi ndlela leyinene`,
's475b08749d0706ed': `Help us inform millions of consumers around the world about what they eat`,
's49730f3d5751a433': `Loading...`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `Nhlayo ya Swikumiwa`,
's4df2f533c0c1e7d0': `Swilawuri swa swifaniso`,
's4e94adf723979402': `Open Food Facts needs your help with this product.`,
's4f4886341969d552': `Ku hlawula ku rhurhela`,
's4f751fb9b3ed766c': `Ku Tumbuluxa Nhundzu Leyintshwa`,
's547c12ae169d00bc': `Available on F-Droid`,
's5560fb119e40923d': `Nghenisa vito ra ndhawu...`,
's55d7249883a98ca1': `mayelana na ndhawu leyi eka Open Food Facts wiki`,
's565867d84c04aea2': `Swihlawulekisi swa xisefo...`,
's5666afe5cd0166de': `Hi kombela u lulamisa swihoxo kutani u cinca tsalwa u nga si tiyisisa`,
's57472465a23b41db': `Values`,
's58e1eeea7a60ae51': `Ku layicha switirhisiwa...`,
's59df20feee978e5b': `Error: Invalid value.`,
's5c92c0051d44b6de': `Hi pfuneni ku lulamisa rungula ra swakudya.`,
's5dd6f12783fca34f': `Hlela nxaxamelo wa swiaki`,
's5e8250fb85d64c23': `Close`,
's5ed03bb1f3a15949': `Picture`,
's6306a31415aea913': `I SUPPORT`,
's6498dfe4855bb3a7': `unit`,
's64ef2a6c2dd1d3d1': `Edit`,
's66413c24dcf680e2': `Skip`,
's67ae6594857a4d57': `Thanks for your contribution!`,
's6cee7cad81dfedd1': `Xifaniso lexi tsemiweke`,
's6d7b6cdedaadfb6e': `Each donation counts! We appreciate your support in bringing further food transparency in the world.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`Ntwanano lowunene ${0}% .`,
's71a5c9f4b68ef4d4': `Count`,
's74cb3d66f6a668e1': `Matsalwa ya matsalwa`,
's787dd11bed0dc88a': `Cinca sayizi ya ximatsi`,
's7ce4fd9430e80cea': `value`,
's801a05fa8e881f37': `Dyondza swo tala hi ku tumbuluxiwa ka nhundzu na swiletelo:`,
's8038273de2cf8b73': `Hi kombela u hlawula xifundzha lexi u nga ta byala.`,
's839cc2908a5387f2': `Sefa tibarkhodi...`,
's86197dcf3e96af64': `Pfula na ku lavisisa swihlawulekisi leswi nga kona`,
's8a63be30a129a59c': `Cinca sayizi ya le hansi`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `Cinca sayizi ehenhla exineneni`,
's8db84aa4bc949af2': `Tsala Nhundzu Leyintshwa`,
's8f839a03997a16d7': `Languta Xiendliwa`,
's901ae1e236ac45d3': `Khansela ku susiwa`,
's907f7a97c6b29425': `Tiva leswaku modele wa data wu nga ha cinciwa. Tirhisa hi khombo ra wena n’wini.`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `Swinyunyeteri :`,
's9a7f60fce090ecaf': `Ku tsandzekile ku layicha swihlawulekisi. Hi kombela u ringeta nakambe endzhaku.`,
's9b87abd68fb9df45': `A swi kumeki? Endla xilotlelo lexintshwa {value}`,
's9c0f52425fd2f07e': `Swi Nga ha endleka Swi Nga Fanisi`,
's9fc41f789c63b40d': `Products`,
'sa1fa766e0d5634d7': `Ku hava Xikoro Lexi Nga Kona`,
'sa548778b24054030': `Languta tindhawu hinkwato leti hoxeke xandla ku suka eka phurojeke ya Folksonomy Engine. Swihlawulekisi leswi swi nyika metadata yo engetela na vutivi mayelana na swikumiwa eka database ya Open Food Facts.`,
'sa63907958bd0ec4b': `Cinca sayizi ehenhla eximatsini`,
'sa95b4224f685a36a': `Pfala modal`,
'sab56a1d439576fd6': `Xifaniso xa xiringanyeto`,
'sac47ea2901d04c15': `Cinca sayizi ehansi eximatsini`,
'sb125227d436c2925': `Lavisisa mhaka ya wena ya nhundzu eka database ya nhundzu leyi nga kona:`,
'sb125568d43642e6f': `Hlamula swivutiso mayelana na xiendliwa.`,
'sb1c538e038f9b214': str`Match ya kahle swinene ${0}%`,
'sb28639570ff3b852': `nxaxamelo wa tindhawu hinkwato`,
'sb3bdd638a58d30f4': `engage a community of committed citizens,`,
'sb3cbcc1bd0fff140': `Loko se u tiyisisile leswaku nhundzu ya wena a yi kona naswona vaaki va pfumela leswaku ya pfuna, u fanele ku rhanga u yi tsala eka wiki.`,
'sb3d4f79d9d8b71e5': `Submit`,
'sb560fa37a7bfb6c2': `Ku hava switirhisiwa leswi kumiweke eka ndhawu leyi.`,
'sb7f72e4c8a2d3357': `Mimpimo ya xisefo...`,
'sb8178320160f84ea': `Kombisa swibyariwa`,
'sbad7d2734149470b': `Validate`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd6be5cde472f37c': `Vutivi hinkwabyo byi hlamuriwile! Ndza khensa mpfuno wa n'wina!`,
'sbd9a0b2293b3cd3c': `Serving size`,
'sbe472dc3c2685985': `Nkoka lowu Fambelanaka`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `Cinca sayizi ya le henhla`,
'sc1c08d0cbcc3bd24': `A Swi Fani`,
'sc52696641af72b53': `Install the app!`,
'sc5575e3107f87874': `Rotate image to the left`,
'sc57b630a7a70c61f': `Ku lulamisiwa loku ringanyetiweke`,
'sc681b137e8f604f7': `Confirm deletion`,
'sc6daf8a31883f8b9': `Susa xifaniso`,
'sc895972c88d38ca5': `Nhundzu ya folksonomy`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scace072bef961918': `Tilayini`,
'scb3b0671d7b7f640': `Nkoka lowuntshwa`,
'scb489a1a173ac3f0': `Yes`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `Hlanganyela eka Nkulumo ya Slack`,
'scdb6cad0b92721bf': `Ku hava tindhawu leti kumiweke.`,
'scf23a05631f93732': `Tiyisisa Ku Susa`,
'scfed2f270ef6a3aa': `Hlawula ndhawu`,
'sd1022bc1ef9204f7': `Xifaniso lexi nga xisiwaka`,
'sd1077c055cf9ba6b': `Hi pfuneni ku tiyisisa nxaxamelo wa swiaki swa xiendliwa.`,
'sd698d21ddecba56b': `Heyi! U nga hi pfuna ku antswisa vuxokoxoko bya xiendliwa hi ku hlamula swiphemu leswi landzelaka:`,
'sd82bc2decefa621b': `remain independent of the food industry,`,
'sdb97e5976482606e': `Languta loko nhundzu se yi ri kona`,
'sdbf806fefc584115': `U fanele ku kuma a`,
'sdc673e73b5c13aea': `Delete`,
'sdc792b75f1edcaba': `Hi pfuneni ku lulamisa mapeletelo ya swiaki.`,
'sdca5deead576ceee': `Cinca sayizi ehansi exineneni`,
'sdcc2555c5dde524f': `Xana wa tiyiseka leswaku u lava ku susa nchumu lowu? Xiendlo lexi a xi nge tlheriseriwi endzhaku.`,
'se206feec7ec57b28': `per 100g`,
'se419a9ab36987490': `Swi nga tirhi`,
'se5127cf0f92e7e48': `Xitsundzuxo: u nga ha tlhela u kuma`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sec6377f3c4e9b28c': `Ndzi ta ringanyeta xibyariwa xo antswa`,
'seea3800e27baa686': `Swikumiwa swa munhu hi xiyexe`,
'sefaba4adc4ec9219': `Swihlawulekisi swa Folksonomy`,
'seffa8ca49175b5f0': `Swilo leswi endleriweke munhu hi xiyexe`,
'sf44a6b3b232c28ea': str`Cinca ntikelo wa sweswi hi ${0}`,
'sf4cd86a2f5ef2588': `Barcode ya Xiendliwa`,
'sf57a61152168cc81': `Hi pfuneni ku lulamisa ku kumiwa ka swiaki`,
'sf88b90b8ba23871c': `Ntwanano lowu nga tiviwiki`,
'sf9aee319a006c9b4': `Add`,
'sfacbbe968fa7d773': `Vito ra ndhawu:`,
'sfc40ea3d5d5aa6f8': `Your donations fund the day-to-day operations of our non-profit association:`,
'sfe87465d50530725': `Nkoka lowu fambelanaka`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  